import { Container, Stack } from '@mui/material';
import { useInView } from 'react-intersection-observer';
import { useParams } from 'react-router-dom';
import { END_OF_HISTORY_INDEX } from '@tt/common';
import { useAppDispatch, useAppSelector } from '../../app/hooks'
import { AsyncWrapper, Loading } from '../async';
import './tracker.css'
import { loadHistory, LoadHistoryProps } from './trackerSlice';
import { ZoneList } from './zoneList';

const DEFAULT_LADDER = 'ladder';

export const History = () => {
  const { pastZones, nextHistoryIndex } = useAppSelector(state => state.tracker);
  const { ladder } = useParams();
  const dispatch = useAppDispatch();
  const { ref } = useInView({
    onChange: (inView) => {
      if (inView) {
        console.log('Fetching next batch');
        const loadHistoryProps: LoadHistoryProps = {
          ladder: ladder || DEFAULT_LADDER,
          numHours: 5,
        }
        if (nextHistoryIndex !== END_OF_HISTORY_INDEX) {
          loadHistoryProps.startingHour = nextHistoryIndex;
        }
        dispatch(loadHistory(loadHistoryProps));
      }
    },
  })
  return <Container>
    <h2>History</h2>
    <ZoneList zones={pastZones} />
    {nextHistoryIndex !== END_OF_HISTORY_INDEX && <div ref={ref}>
      <Loading />
    </div>}
  </Container>
}